import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BrandService } from '../brand/brand.service';
@Injectable({
    providedIn: 'root'
})
export class commonFunctionService {

    constructor(private router: Router, private brandService: BrandService) { }

    // A cookie's Domain attribute must match the page's actual hostname (or
    // a parent of it) or the browser silently drops the whole write — e.g.
    // "domain=bluewings.in" is rejected outright on localhost or on any
    // other brand's domain. Omitting the attribute defaults it to the
    // current host, which is always valid, so that's the safe fallback
    // whenever the active brand's domain isn't actually a suffix of where
    // the page is running (local dev, previews, an unregistered domain).
    private cookieDomainAttribute(): string {
        const domainSuffix = this.brandService.brand.domainSuffix;
        if (domainSuffix && window.location.hostname.endsWith(domainSuffix)) {
            return "domain=" + domainSuffix + "; ";
        }
        return "";
    }

    // The legacy login wrote the session straight into localStorage; the new
    // login writes cookies only, and every page then falls back to the cookie
    // only when localStorage is EMPTY. A stale usertoken/schoolinfo/schoolAllInfo
    // left over from an earlier session therefore beat the fresh cookies, so
    // the header's school name and class-config data stayed blank/wrong until a
    // refresh happened to re-derive them. Mirroring the fresh cookies into
    // localStorage at login (and dropping the cached school info) fixes that.
    syncSessionCookiesToLocalStorage(): void {
        const keys = ['usertoken', 'schoolinfo', 'loginMode', 'adminType', 'isFranchise', 'fkFranchiseId',
            'currency', 'countryCode', 'adminPermissionlist', 'extensionServices', 'staffName'];
        const cookies = document.cookie.split('; ');
        keys.forEach((key) => {
            const match = cookies.find((c) => c.startsWith(key + '='));
            if (match) {
                const rawValue = match.substring(key.length + 1);
                let value = rawValue;
                try {
                    value = decodeURIComponent(rawValue);
                } catch {
                    value = rawValue;
                }
                if (value && value !== 'null' && value !== 'undefined') {
                    localStorage.setItem(key, value);
                }
            }
        });
        localStorage.removeItem('schoolAllInfo');
    }

    setCookie(name: any, value: any, days: any) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        const domain = this.cookieDomainAttribute();
        const path = "path=/";
        const sameSite = "SameSite=Lax";
        const secure = location.protocol === 'https:' ? "Secure" : "";
        // Guard against writing the literal string "null"/"undefined" —
        // template-literal coercion of a nullish value does that silently,
        // and every later read-back of this cookie would then treat that
        // string as a real value instead of "not set".
        const safeValue = (value === null || value === undefined) ? "" : value;
        document.cookie = `${name}=${safeValue}; ${expires}; ${domain}${path}; ${sameSite}; ${secure}`;
    }

    setCookieLocal(name: any, value: any, days: any) {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    disableBackButton() {
        this.router.events.subscribe(() => {
            history.pushState(null, null, location.href);
            window.onpopstate = function (event) {
                history.go(1);
            };
        });
    }


    appendHeader(){
        const token = localStorage.getItem('usertoken');
        return new HttpHeaders().append('Content-Type', 'application/json').append('token', token);
      }

    deleteAllCookies() {
        const cookies = document.cookie.split("; ");
        cookies.forEach(cookie => {
            const eqPos = cookie.indexOf("=");
            const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
            const domain = this.cookieDomainAttribute();
            const path = "path=/";
            const expires = "expires=Thu, 01 Jan 1970 00:00:00 GMT";
            const sameSite = "SameSite=Lax";
            const secure = location.protocol === 'https:' ? "Secure" : "";
            document.cookie = `${name}=; ${expires}; ${domain}${path}; ${sameSite}; ${secure}`;
        });
    }

    deleteAllLocalCookies() {
        const cookies = document.cookie.split("; ");
        cookies.forEach(cookie => {
            const eqPos = cookie.indexOf("=");
            const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
            const path = "path=/";
            const expires = "expires=Thu, 01 Jan 1970 00:00:00 GMT";
            document.cookie = `${name}=; ${expires}; ${path}`;
        });
    }

    handleKeyDown(event: KeyboardEvent): void {
        const allowedKeys = [
            "ArrowLeft",
            "ArrowRight",
            "Backspace",
            "Delete",
            "Home",
            "End",
            "Tab",
        ];
        if (event.ctrlKey || event.metaKey) {
            return;
        }
        if (!/^\d$/.test(event.key) && !allowedKeys.includes(event.key)) {
            event.preventDefault();
        }
    }
    
    getFileTypeFromUrl(url: string): string {
        const extension = url.split('.').pop()?.toLowerCase();
        if (['pdf'].includes(extension)) {
            return 'application/pdf';
        } else if (['png', 'jpg', 'jpeg'].includes(extension)) {
            return 'image';
        } else {
            return 'unknown';
        }
    }
     generateDummyArray(count: number): any[] {
    return Array.from({ length: count }, () => ({}));
  }

   getSingleId(list: any[], key: string) {
    return list && list.length === 1 ? list[0][key] : null;
  }

    getFadedColor(hex: string = "#32a852", amount: number = 0.5): string {
        hex = hex.replace('#', '');

        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        const fadedR = Math.round(r + (255 - r) * amount);
        const fadedG = Math.round(g + (255 - g) * amount);
        const fadedB = Math.round(b + (255 - b) * amount);

        return `#${fadedR.toString(16).padStart(2, '0')}${fadedG.toString(16).padStart(2, '0')}${fadedB.toString(16).padStart(2, '0')}`;
    }

}